import React from 'react';
import { useNotifications } from '../context/NotificationContext';
import Button from '../components/ui/Button';
import EmptyState from '../components/ui/EmptyState';
import { Bell, Check } from 'lucide-react';
import { formatDateTime } from '../utils/helpers';

const NotificationList = () => {
  const { notifications, markAsRead } = useNotifications();

  return (
    <>
      <div className="mb-6 flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Notifications</h1>
          <p className="text-sm text-gray-500">Stay updated with latest activities</p>
        </div>
        {notifications.some(n => !n.isRead) && (
          <Button variant="secondary" onClick={() => markAsRead('all')}>
            <Check className="w-4 h-4 mr-2" /> Mark all as read
          </Button>
        )}
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        {notifications.length > 0 ? (
          <ul className="divide-y divide-gray-200">
            {notifications.map((notification) => (
              <li 
                key={notification.id} 
                className={`p-4 hover:bg-gray-50 transition-colors ${!notification.isRead ? 'bg-blue-50' : ''}`}
              >
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 pt-1">
                    <Bell className={`w-5 h-5 ${!notification.isRead ? 'text-blue-500' : 'text-gray-400'}`} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className={`text-sm text-gray-900 ${!notification.isRead ? 'font-semibold' : ''}`}>
                      {notification.message}
                    </p>
                    <p className="text-xs text-gray-500 mt-1">
                      {formatDateTime(notification.createdAt)}
                    </p>
                  </div>
                  {!notification.isRead && (
                    <button
                      onClick={() => markAsRead(notification.id)}
                      className="text-xs text-blue-600 hover:text-blue-800 font-medium"
                    >
                      Mark as read
                    </button>
                  )}
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <EmptyState 
            title="No notifications" 
            description="You're all caught up! Check back later for updates." 
          />
        )}
      </div>
    </>
  );
};

export default NotificationList;
